import {
  useQParam,
  Contact,
  Button,
  PlusIcon,
  SearchBar,
  SearchIcon,
} from '@trufla-technology/trumarket-react-design-system';
import {
  useAssignUsersToTeams,
  useGetTeams,
} from '@trufla-technology/trufla-trudomain/dist/lib/truMarket';
import { getTitleCase } from 'app/utils';
import { useState } from 'react';
import { NewTeamLoading } from './NewTeamLoading';
import './style.scss';

type Props = {
  refetchTeams?: () => void;
  teamsKeysString?: string;
};

export const NewTeam = ({ refetchTeams, teamsKeysString }: Props) => {
  const userKey = useQParam('userKey');
  const assignUsersToTeams = useAssignUsersToTeams();
  const [searchValue, setSearchValue] = useState<string>();

  const { data, handleFilter, removeFilters } = useGetTeams({
    paginate: {
      limit: 50,
      offset: 0,
    },
  });

  const teams = teamsKeysString
    ? data?.filter((team) => !teamsKeysString.split(',')?.includes(team.key!))
    : data;

  const handleAssignUserToTeams = async (teamKey: string) => {
    await assignUsersToTeams({
      assigning: [
        {
          teamKey,
          userKey: userKey!,
        },
      ],
    });
    refetchTeams?.();
  };

  const handleSearch = (value: string) => {
    setSearchValue(value);
    if (!value?.trim().length) return removeFilters(['name']);
    handleFilter({
      name: value,
    });
  };

  if (!teams) return <NewTeamLoading />;

  return (
    <div className="add-team-container">
      <SearchBar
        placeholder="Search"
        onSearch={handleSearch}
        icon={<SearchIcon fill="#54616C" />}
        value={searchValue || ''}
      />
      {teams?.map(({ key, name, usersCount }) => (
        <Contact
          key={key}
          name={getTitleCase(name!)}
          email={`${usersCount} Member`}
          button={
            <Button onClick={() => handleAssignUserToTeams(key!)}>
              <PlusIcon size="extra-medium" fill="var(--tru-white)" />
            </Button>
          }
        />
      ))}
    </div>
  );
};
